import { useEffect } from "react";
import { ShiftItem } from "../../../../interface/shift";
import { useSelector, useDispatch } from "react-redux";
import { setLoaded } from "../../../../app/commonplace";
import {
  Calendar,
  Clock,
  ChevronRight,
  Users,
  Heart,
  ThumbsUp,
} from "lucide-react";

const ShiftsConfirmed = (props: any) => {
  const commonplace = useSelector((state: any) => state.commonplace);
  const device = useSelector((state: any) => state.commonplace.device);
  const dispatch = useDispatch();

  useEffect(() => {
    console.log("456");
    dispatch(
      setLoaded({
        loaded: true,
      }),
    );
    if (device !== "h5") return;
    const t = setTimeout(() => {
      props.list.forEach((item: ShiftItem) => {
        let nameHeight = document.getElementById(item.id)?.offsetHeight;
        if (nameHeight && nameHeight > 20) {
          let profile = document.getElementById(`profile${item.id}`);
          if (profile) profile.className = "profile pad-top-0";
        }
      });
    }, 1000);
    return () => {
      clearTimeout(t);
    };
  }, []);

  return (
    <div className="min-h-[200px] overflow-hidden">
      <div className="space-y-2 overflow-hidden">
        {props.list.map((item: ShiftItem) => {
          return (
            <div
              onClick={() => {
                props.navigate(item.id, item.shiftsId);
              }}
              key={item.id}
              className={`bg-card/95 border border-border rounded-lg cursor-pointer hover:shadow-md hover:scale-[1.005] transition-all duration-300 ease-out p-2 sm:p-3 md:py-2 md:px-1`}
            >
              <>
                {/* Mobile Layout - Stacked vertically */}
                <div className="relative block md:hidden">
                  {/* Blue indicator on the left */}
                  <div
                    className={`absolute left-0 top-0 bottom-0 w-1 rounded-r ${
                      item.status === "error" ? "bg-destructive" : "bg-primary"
                    }`}
                  ></div>

                  {/* First row - Date and Time with safe margins */}
                  <div className="flex flex-col space-y-3 pl-6 pr-4 mb-3 w-full">
                    <div className="flex items-center">
                      <div className="text-[10px] font-semibold text-muted-foreground/70 w-10 flex-shrink-0">
                        Date
                      </div>
                      <div className="flex items-center text-xs font-semibold text-foreground/80 flex-1">
                        <Calendar className="mr-2 text-muted-foreground w-3 h-3" />
                        <span>{item.date}</span>
                      </div>
                    </div>
                    <div className="flex items-center">
                      <div className="text-[10px] font-semibold text-muted-foreground/70 w-10 flex-shrink-0">
                        Time
                      </div>
                      <div className="flex items-center text-xs font-semibold text-foreground/80 flex-1">
                        <Clock className="mr-2 text-muted-foreground w-3 h-3" />
                        {item.time && !item.time.includes("NaN") ? (
                          <>
                            <span>{item.time}</span>
                            <span className="text-muted-foreground/50 ml-2 text-[10px] flex-shrink-0">
                              ({item.duration})
                            </span>
                          </>
                        ) : (
                          <span className="text-muted-foreground/50 text-[10px]">
                            Time not available
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Second row - Applicants, Doctor Info */}
                  <div className="flex items-start w-full pl-6 pr-4 gap-2">
                    <div className="flex flex-col flex-1 gap-2">
                      {/* Row 1: Doctor Info */}
                      <div className="flex items-center gap-2 mb-1">
                        {item.avatar ? (
                          <img
                            src={item.avatar}
                            alt={item.name}
                            className="w-6 h-6 rounded-full object-cover border border-border"
                          />
                        ) : (
                          <div className="w-6 h-6 rounded-full bg-secondary flex items-center justify-center text-[10px] font-bold text-secondary-foreground">
                            {item.name ? item.name.charAt(0) : "?"}
                          </div>
                        )}
                        <span className="text-xs font-medium text-foreground truncate">
                          {item.name || "Unknown Doctor"}
                        </span>
                      </div>

                      {/* Row 2: Applicants */}
                      <div className="flex items-center gap-2">
                        <span className="text-[10px] font-medium text-muted-foreground">
                          Applicants:
                        </span>
                        <span className="text-xs font-bold text-foreground">
                          {item.applicants}
                        </span>
                      </div>

                      {/* Row 3: Tags */}
                      {(item.specialty || item.skillLevel) && (
                        <div className="flex flex-wrap gap-1.5">
                          {item.specialty && (
                            <span className="px-1.5 py-0.5 bg-purple-50 text-purple-700 border border-purple-200 rounded text-[9px] font-medium">
                              {item.specialtyName || item.specialty}
                            </span>
                          )}
                          {item.skillLevel && (
                            <span className="px-1.5 py-0.5 bg-indigo-50 text-indigo-700 border border-indigo-200 rounded text-[9px] font-medium">
                              {item.skillLevelName || item.skillLevel}
                            </span>
                          )}
                        </div>
                      )}
                    </div>

                    <ChevronRight className="text-muted-foreground w-4 h-4 flex-shrink-0 mt-1" />
                  </div>
                </div>

                {/* Desktop/Tablet Layout - Compact Single Row */}
                <div className="hidden md:flex items-center relative min-h-[56px]">
                  {/* Blue indicator on the left */}
                  <div
                    className={`absolute left-0 top-0 bottom-0 w-1 rounded-r ${
                      item.status === "error" ? "bg-destructive" : "bg-primary"
                    }`}
                  ></div>

                  {/* Date & Time */}
                  <div className="flex items-center gap-4 pl-4 pr-4 border-r border-border/50 min-w-[280px]">
                    <div className="flex items-center gap-1.5">
                      <Calendar className="text-muted-foreground w-3.5 h-3.5" />
                      <span className="text-sm font-semibold text-foreground">
                        {item.date}
                      </span>
                    </div>
                    <div className="flex items-center gap-1.5">
                      <Clock className="text-muted-foreground w-3.5 h-3.5" />
                      <span className="text-sm text-foreground/80">
                        {item.time}
                      </span>
                      <span className="text-[10px] text-muted-foreground bg-secondary/50 px-1.5 py-0.5 rounded">
                        {item.duration}
                      </span>
                    </div>
                  </div>

                  {/* Role Tags */}
                  <div className="flex items-center gap-2 px-4 border-r border-border/50 flex-1">
                    <span className="px-2 py-0.5 bg-primary/10 text-primary border border-primary/20 rounded text-xs font-semibold">
                      {item.specialtyName || item.specialty || "General"}
                    </span>
                    {item.skillLevel && (
                      <span className="px-2 py-0.5 bg-secondary text-secondary-foreground border border-secondary-foreground/10 rounded text-xs">
                        {item.skillLevelName || item.skillLevel}
                      </span>
                    )}
                  </div>

                  {/* Confirmed Doctor Info */}
                  <div className="flex items-center gap-3 px-4 border-r border-border/50 flex-[1.5]">
                    {item.avatar ? (
                      <img
                        src={item.avatar}
                        alt={item.name}
                        className="w-8 h-8 rounded-full object-cover border border-border"
                      />
                    ) : (
                      <div className="w-8 h-8 rounded-full bg-secondary flex items-center justify-center text-xs font-bold text-secondary-foreground">
                        {item.name ? item.name.charAt(0) : "?"}
                      </div>
                    )}
                    <div className="flex flex-col">
                      <span className="text-sm font-medium text-foreground truncate max-w-[150px]">
                        {item.name || "Unknown Doctor"}
                      </span>
                      <span className="text-[10px] text-muted-foreground">
                        Confirmed Doctor
                      </span>
                    </div>
                  </div>

                  {/* Candidates Stats - Inline */}
                  <div className="flex items-center gap-4 px-4">
                    <div className="flex items-center gap-1">
                      <span className="text-[10px] text-muted-foreground">
                        Applicants:
                      </span>
                      <span className="text-base font-bold text-foreground">
                        {item.applicants}
                      </span>
                    </div>
                  </div>
                </div>
              </>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ShiftsConfirmed;
